/** Billing-profile data-access layer — maps the shared `myMemberInfo` query to a billing address. */

import type { MyMemberInfo } from '@/hooks/member/memberInfoApi';
import type { BillingAddressValues } from '@/lib/payments/paymentAccount.types';

export interface MemberBillingProfile {
  savedAddress: BillingAddressValues | null;
}

export function mapToBillingProfile(member: MyMemberInfo): MemberBillingProfile {
  const mailingAddress = member?.mailingAddress;
  if (!mailingAddress) {
    return { savedAddress: null };
  }
  return {
    savedAddress: {
      name: `${member?.firstName ?? ''} ${member?.lastName ?? ''}`.trim(),
      line1: mailingAddress.line1 ?? '',
      line2: mailingAddress.line2 ?? '',
      city: mailingAddress.city ?? '',
      state: mailingAddress.state ?? '',
      zip: mailingAddress.zip ?? '',
    },
  };
}
